/**
 * How a model is titled: its number, a dot, its name — or the name alone when
 * the number only repeats it (decision 222).
 *
 * Rain filled the model number with the model's name for about half the
 * shop's models, so a heading of number · name read "ATOMIC NEXUS 120 BOA ·
 * ATOMIC NEXUS 120 BOA" down every report and count sheet. The reports' SQL
 * (apps/api reports/model-label.ts) makes the same comparison: trimmed, any
 * case.
 */

/** The number worth showing beside the name, or null when it repeats the name. */
export function shownModelNumber(styleNumber: string | null, name: string): string | null {
  if (styleNumber === null || styleNumber.trim() === '') return null;
  return styleNumber.trim().toUpperCase() === name.trim().toUpperCase() ? null : styleNumber;
}

/** "AE5030320 · HAWX PRIME XTD 120", or "ATOMIC NEXUS 120 BOA" once. */
export function modelTitle(styleNumber: string | null, name: string): string {
  const number = shownModelNumber(styleNumber, name);
  return number === null ? name : `${number} · ${name}`;
}
